document.addEventListener("DOMContentLoaded", function () {

    // Function to toggle display
    var toggleDisplay = function () {
        var ifbiResultPanels = document.getElementsByClassName("ifbi-result-panel");
        var agentViewToggles = document.getElementsByClassName("agent-view-toggle");

        for (var agentresult = 0; agentresult < ifbiResultPanels.length; agentresult++) { 
            ifbiResultPanels[agentresult].style.display = "block";
        }

        for (var viewtoggle = 0; viewtoggle < agentViewToggles.length; viewtoggle++) { 
            agentViewToggles[viewtoggle].style.display = "none";
        }
    };

    // Check current URL
    var currentUrl = window.location.href;

    if (currentUrl.includes("find-agent/ByLocation/") || currentUrl.includes("find-agent/ByName/")) {
        toggleDisplay();
    }

});
